export const state = () => ({
  sessionsEventAlias: "",
  hasSessions: null,
})

export const getters = {
  hasSessions: state => state.hasSessions,
}

export const mutations = {
  SET_HAS_SESSIONS (state, { eventAlias, hasSessions }) {
    state.sessionsEventAlias = eventAlias
    state.hasSessions = hasSessions
  },
}

export const actions = {
  async fetchHasSessions ({ state, commit }, eventAlias) {
    if (!eventAlias) return

    if (state.sessionsEventAlias === eventAlias && state.hasSessions !== null)
      return

    const [res, err] = await this.$api.program.countProgramSessions({
      params: { event: eventAlias },
    })

    if (err) {
      console.error(err)
      return
    }

    commit("SET_HAS_SESSIONS", {
      eventAlias,
      hasSessions: (res?.pagination?.total || 0) > 0,
    })
  },
}
